export default "__VITE_PUBLIC_ASSET__5dbdb9be__"